module.exports = "<div class=\"container\"><p>The delete user and user index api routes are restricted to users with the 'admin' role.</p><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"user in admin.users\"><strong>{{user.name}}</strong><br/><span class=\"text-muted\">{{user.email}}</span><a class=\"trash\" ng-click=\"admin.delete(user)\"><span class=\"glyphicon glyphicon-trash pull-right\"></span></a></li></ul></div>";


//////////////////
// WEBPACK FOOTER
// ./client/app/admin/admin.pug
// module id = 263
// module chunks = 0